module.exports = __webpack_public_path__ + "media/images/lps-eatout-ad3ca35b.png";